<template>
    <div class="w-full h-36 flex bg-black">
        <div class="logo-container">
            <Link href="/"  class="logo"

                ><img
                    src="/images/pegasus-logo.png"
                    alt="Pegasus Logo"
            /></Link>
        </div>
        <div class="w-full text-white items-center xl:flex lg:flex md:hidden sm:hidden hidden">
            <div class="w-1/3 flex items-center">
                <img
                    class="user-avatar inline"
                    :src="'/avatar/' + $page.props.image"
                    alt=""
                />
                <div class="inline ml-2">
                    <h2 class="text-2xl font-semibold">
                        {{ $page.props.auth.user.first_name }}
                         {{ $page.props.auth.user.surname }}
                    </h2>
                    <p>{{ $page.props.auth.user.site }}</p>
                    <p>{{ $page.props.auth.user.department }}</p>
                </div>
            </div>
            <div class="w-2/3">
                <Link href="/logout" class="float-right">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="inline h-6 w-6 mr-1"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        />
                    </svg>
                    <p class="inline text-white mr-5">Logout</p>
                </Link>
            </div>
        </div>
        <div class="xl:hidden lg:hidden md:show show w-full flex items-center justify-end cursor-pointer" @click="toggleMobileMenu()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mr-2" fill="none" viewBox="0 0 24 24" stroke="white">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
        </div>
    </div>
    <div class="mobile-menu" :class="showMobileMenu ? 'absolute' : 'mob-hidden' ">
        <div class="mobile-x" @click="toggleMobileMenu()">X</div>
       <div class="relative">
            <div class="w-full">
                <img
                    class="user-avatar inline"
                    :src="'/avatar/' + $page.props.image"
                    alt=""
                />
                <div class="inline ml-2">
                    <h2 class="text-2xl font-semibold">
                        {{ $page.props.auth.user.first_name }}
                         {{ $page.props.auth.user.surname }}
                    </h2>
                    <p>{{ $page.props.auth.user.site }}</p>
                    <p>{{ $page.props.auth.user.department }}</p>
                </div>
            </div>
        <h2 class="mobile-nav-header">Menu</h2>
        <ul class="mobile-nav-menu">
        <Link as="li" href="/skills" @click="toggleMobileMenu()" class="mobile-nav-item">Skills & Competency Record <svg class="w-6 h-6 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 14l9-5-9-5-9 5 9 5z"></path><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"></path></svg></Link>
        <Link as="li" href="/personal-details"  @click="toggleMobileMenu()" class="mobile-nav-item">Personal Details <svg class="w-6 h-6 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path></svg></Link>
        <Link as="li" href="/announcements"  @click="toggleMobileMenu()" class="mobile-nav-item"> Announcements <svg class="w-6 h-6 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path></svg></Link>
        <Link as="li" href="/logout"  @click="toggleMobileMenu()" class="mobile-nav-item"> Logout      
        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="inline h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        />
                    </svg></Link>

        </ul>
        <div v-if="isAdmin == 1 || isViewer == 1" class="mobile-nav-menu">
            <h2 class="mobile-nav-header">Admin Menu</h2>
            <ul class="mobile-nav-menu">
                 <Link as="li" href="/admin/staff"  @click="toggleMobileMenu()" class="mobile-nav-item">Staff 
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 inline"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    >
                    <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                    </svg>
                 </Link>
                 <Link as="li" href="/admin/announcements" @click="toggleMobileMenu()" class="mobile-nav-item">Announcements
                    <svg
                    class="h-6 w-6 inline"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    ></path>
                    </svg>
                 </Link>
                 <Link as="li" href="/admin/reports" @click="toggleMobileMenu()" class="mobile-nav-item">Reports
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 inline"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    >
                    <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                    </svg>
                 </Link>
                 <Link as="li" href="/admin/department" @click="toggleMobileMenu()" class="mobile-nav-item">Departments
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 inline"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    >
                    <path
                    fill-rule="evenodd"
                    d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                    clip-rule="evenodd"
                    />
                    <path
                    d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z"
                    />
                    </svg>
                 </Link>
                 <Link as="li" href="/admin/site" @click="toggleMobileMenu()" class="mobile-nav-item"> Sites
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 inline"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    >
                    <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                    </svg>
                 </Link>
                 <Link as="li" href="/admin/skill" @click="toggleMobileMenu()" class="mobile-nav-item">Skills
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 inline"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    >
                    <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                    </svg>
                 </Link>
                 <Link as="li" href="/admin/skillgroup" @click="toggleMobileMenu()" class="mobile-nav-item">Skill Groups
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 inline"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    >
                    <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                    />
                    </svg>
                 </Link>

            </ul>
        </div>
       </div>
    </div>
    <div class="w-full h-full">
            <!-- <Link class="bg-black text-white font-bold rounded p-3 mx-3 my-2" as="button" :href="$page.props.previousurl" v-if="$page.props.previousurl !== $page.props.currenturl">GO BACK</Link> -->
        <flash-messages />
        <slot />
        <div v-if="isAdmin == 1 || isViewer == 1" class="text-center my-3">
            <Link href="/admin/dashboard"
                ><button
                    class="
                        bg-black
                        text-white
                        font-bold
                        uppercase
                        p-3
                        rounded
                        mt-3
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 inline"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                        />
                    </svg>
                    ADMIN CENTER
                </button></Link
            >
        </div>

        <div class="text-center text-xs">
            <p>Application Version : {{$page.version}}</p>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import FlashMessages from "@/Shared/FlashMessages";
export default {
     data() {
        return {
            showMobileMenu: false,
        }
     },
    methods : {
        toggleMobileMenu(){
            if(this.showMobileMenu){
                this.showMobileMenu = false    
            }else {
                this.showMobileMenu = true    

            }
        }
    },
    components: {
        Link,
        FlashMessages
    },
    props : { isAdmin : Number, isViewer : Number}
};
</script>
